var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showWidget)?_c('div',[_c('div',{attrs:{"id":"whatsapp-widget"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }